import { render, staticRenderFns } from "./ContentContainer.vue?vue&type=template&id=4bd7cb2d&scoped=true&"
import script from "./ContentContainer.vue?vue&type=script&lang=ts&"
export * from "./ContentContainer.vue?vue&type=script&lang=ts&"
import style0 from "./ContentContainer.vue?vue&type=style&index=0&id=4bd7cb2d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd7cb2d",
  null
  
)

export default component.exports